import { useLocation } from 'react-router';

import { appendSignupParams } from '@/auth/utils/signupParams';
import Button from '@/components/Button/Button';
import Link from '@/components/Link';

import s from './SelectSignupType.module.scss';

const SelectSignupType = ({ nextUrl, subdomain }: any) => {
  // Carries a social sign-up from the login page to either form (ENG-6169).
  const { search, state } = useLocation();
  // next must be encoded: it is a whole URL, so an unencoded '#' in it turns
  // everything after into a fragment — silently eating the trial_days appended
  // below (ENG-5527), and an unencoded '&' truncates next itself.
  const queryPart = nextUrl ? `?next=${encodeURIComponent(nextUrl)}` : '';
  const subdomainPart = subdomain ? `/${subdomain}` : '';

  return (
    <div className={s.root}>
      <h2 className={s.title}>Are you interested in finding an Expert or becoming an Expert?</h2>

      <h4 className={s.subTitle}>You can always change this later</h4>

      <div className={s.actions}>
        {/* Campaign params are forwarded on the customer path only — trial_days
            is an SMB subscription concept and means nothing to expert signup. */}
        <Link
          className={s.clientAction}
          to={appendSignupParams(`${subdomainPart}/signup/customer${queryPart}`, search)}
          state={state}
        >
          <Button size="large" style={{ width: 225 }}>
            Find an Expert
          </Button>
        </Link>
        <Link
          className={s.expertAction}
          to={`${subdomainPart}/signup/expert${queryPart}`}
          state={state}
        >
          <Button size="large" style={{ width: 225 }}>
            Become an Expert
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default SelectSignupType;
